var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_33",
    "data-name": "Union 33",
    fill: "white",
    d: "M128.13,477.824a257.571,257.571,0,0,1-72.324-62.292v33.538h-30V365.162H106.02v30H77.938A225.581,225.581,0,0,0,256,482,226,226,0,0,0,482,256h30A256.064,256.064,0,0,1,128.13,477.824Zm128.06-70.432c-2.8,0-5.627-.077-8.447-.23a151.709,151.709,0,0,1-47.133-10.189l35.04-35.725V252.023L202.726,218.24V160.086L167.995,132.8a150.017,150.017,0,0,1,87.816-28.2c2.8,0,5.627.076,8.447.23a151.745,151.745,0,0,1,46.337,9.888L276.9,165.18V222.7l48.263,78.441,0,89.6a150.1,150.1,0,0,1-68.965,16.66ZM143.273,357.05a151.4,151.4,0,0,1,1.814-204.091l27.639,21.712v55.771l32.924,33.782v84.767l-32.883,33.525A152.335,152.335,0,0,1,143.273,357.05Zm211.887-64.4L306.9,214.205V174.278l30.656-45.9a152.187,152.187,0,0,1,31.174,26.573A151.391,151.391,0,0,1,357.05,368.728c-.625.56-1.256,1.107-1.889,1.655ZM0,256A256.027,256.027,0,0,1,451.17,90.29V60.365h30v80.156l-81.1-.027.01-30,28.9.01A226.021,226.021,0,0,0,30,256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrs);
export default __webpack_public_path__ + "static/media/GRS.25f0e6023a00fc8212eb4de8d01b61f3.svg";
export { ForwardRef as ReactComponent };